import React from 'react';
import {
  VStack,
  Box,
  Icon,
  Text,
  Heading,
  useColorModeValue
} from '@chakra-ui/react';
import { FiBook } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const Header: React.FC = () => {
  const { t } = useTranslation();

  const accentColor = useColorModeValue('blue.500', 'blue.400');
  const successColor = useColorModeValue('green.500', 'green.400');
  const mutedTextColor = useColorModeValue('gray.600', 'gray.300');

  return (
    <VStack spacing={6} textAlign="center">
      <Box position="relative">
        <Icon
          as={FiBook}
          fontSize="5xl"
          color={accentColor}
          filter="drop-shadow(0 0 30px rgba(59, 130, 246, 0.5))"
        />
        <Box
          position="absolute"
          top="-2"
          right="-2"
          w="8"
          h="8"
          bg={successColor}
          borderRadius="full"
          display="flex"
          alignItems="center"
          justifyContent="center"
          animation="pulse 2s infinite"
        >
          <Text fontSize="xs" fontWeight="bold" color="white">
            4
          </Text>
        </Box>
      </Box>

      <VStack spacing={4}>
        <Heading
          size="2xl"
          bgGradient="linear(to-r, blue.400, purple.500)"
          bgClip="text"
          fontWeight="black"
        >
          {t('onboarding.vocabulary.title')}
        </Heading>
        <Text fontSize="xl" color={mutedTextColor} maxW="3xl">
          {t('onboarding.vocabulary.subtitle')}
        </Text>
      </VStack>
    </VStack>
  );
};

export default Header;